/**
 * utils/company.js
 * Shared IJM letterhead — printed on every T2 document: Invoice Pusat (T2c-1); Surat Jalan
 * Pusat and the Checklist (T2c-2); Invoice Cabang and Surat Jalan Cabang (T2d). ONE constant
 * so five documents can never independently drift on the company's own printed details.
 *
 * Transcribed from a photograph of the client's real invoice (2026-07-28) — confirm against
 * the original paper before go-live. Deliberately carries NO phone number: the real sample
 * has none. (The earlier throwaway print-calibration pilot, `pages/PrintInvoicePilot.js`,
 * invented a phone line and a different placeholder address/NPWP — those were never real;
 * don't carry them over into any new document.)
 */
export const IJM_COMPANY = {
  name: "PT. INDOPART JAYA MAKMUR",
  addressLines: [
    "JL. RAYA PRANCIS KOMPLEK PERGUDANGAN",
    "PERANCIS 77 BLOK A2  RT. 004  RW. 008  BENDA",
    "BENDA KOTA TANGERANG BANTEN - 15125",
  ],
  npwp: "NPWP : 80.793.863.4-402.000",
};

/**
 * The name of the ORIGINAL single cabang branch (Invoice Cabang's letterhead, PRD §5.3) —
 * transcribed from a photograph of a real Invoice Cabang sample (2026-08-02). **Demoted to a
 * fallback-only constant by the multi-branch cabang feature**: there turned out to be three
 * real branches (MMC/AMIN/TMM), not one, so `settings.cabangName` (storage v15) is now
 * vestigial and cabang branches live in the real managed `data.branches` list
 * (`utils/branches.js`) instead. This constant survives as exactly two things: (1) the name
 * `branches.js`'s `defaultBranchId` looks for when picking a sensible default branch (the
 * migration backfill, the inline sales quick-add, Kelola Sales' add-panel default); (2)
 * `InvoiceCabang.js`'s own fallback default parameter for a caller that doesn't pass a
 * `cabangName` prop at all (e.g. a direct-mount test). Confirm the actual branch names against
 * the client before go-live, same caution `IJM_COMPANY` carries.
 */
export const DEFAULT_CABANG_NAME = "MMC";
